import React from "react";
import { FormContact } from "./Form/FromContact";
import { Info } from "./Info/Info";
import style from "./Contact.module.css";

export const Contact = () => {
  return (
    <div className={style.colors} id="contacto">
      <div className={style.container}>
        <Info></Info>
        <FormContact></FormContact>
      </div>
      <div className={style.colorCont}>
        <div className={style.colors1}> </div>
        <div className={style.colors2}> </div>
        <div className={style.colors3}> </div>
      </div>{" "}
    </div>
  );
};
